import { Injectable } from '@angular/core';

import { Duration } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class DurationService {
  /*
    Parses a django serializer duration string into a luxon Duration instance.
    The pattern should look like <DD> HH:MM:SS.
  */
  parse(value: string) {
    if (!value) {
      return null;
    }

    let [
      dayString,
      timeString,
    ] = value.split(' ');

    // In case the days part is missing.
    if (!timeString) {
      timeString = dayString;
      dayString = '0';
    }

    const [
      hours,
      minutes,
      seconds,
    ] = timeString.split(':');

    return Duration.fromObject({
      days: parseInt(dayString, 10),
      hours: parseInt(hours, 10),
      minutes: parseInt(minutes, 10),
      seconds: parseInt(seconds, 10),
    });
  }

  seconds(measure: string | number, unit = 'days') {
    const object = {
      [unit]: measure
        ? parseFloat(measure.toString())
        : 0,
    };

    return Duration
      .fromObject(object)
      .as('seconds')
      .toString();
  }

  duration(measure, unit = 'days') {
    // TODO: Check this
    return Duration
      .fromISOTime(measure)
      .as(unit as any);
  }
}
